<template>
  <div>
    <el-dialog
      width="780px"
      :visible.sync="selfShow"
      :title="id ? '编辑客户' : '新增客户'"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <el-form ref="refForm" size="mini" label-width="130px" :model="detailData" :rules="rules">
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="客户企业名称" prop="customer_name">
                <el-input clearable v-model="detailData.customer_name">
                  <span style="cursor: pointer" slot="suffix" @click="addSuffix">加后缀</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="客户等级">
                <el-input v-model="detailData.history_level" disabled>
                  <template slot="append">成交金额等级</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="所属业务" prop="saler_id">
                <el-select
                  v-if="!isLockSaler"
                  v-model="detailData.saler_id"
                  style="width: 159px"
                  placeholder="可搜索查询"
                  default-first-option
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in saleList"
                    :key="index"
                    :label="item.nick_name"
                    :value="item.id"
                  />
                </el-select>
                <el-input v-else v-model="detailData.sales_man" style="width: 159px" disabled />
                <el-popover
                  placement="top-start"
                  title="历史跟进人"
                  width="160"
                  trigger="hover"
                  :content="detailData.li_shi_ye_wu_yuan_list.join('\n') || '无'"
                >
                  <el-button slot="reference" class="m-l-5" type="primary" size="mini" disabled>
                    历史跟进人
                  </el-button>
                </el-popover>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="提成比例">
                <el-input clearable v-model="detailData.commission_rate">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="联系人">
                <el-input clearable v-model="detailData.linkman" />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="联系人电话">
                <el-input clearable v-model="detailData.phone" @change="checkPhoneRepeat" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="联系人微信">
                <el-input clearable v-model="detailData.wei_xin" />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="主营产品">
                <el-input clearable v-model="detailData.zhu_ying_chan_pin" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="客户行业分类">
                <c-cascader-industry-category
                  :list.sync="detailData.suo_shu_hang_ye"
                  checkStrictly
                />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="询盘产品分类">
                <c-cascader-category
                  :list.sync="detailData.xun_pan_chan_pin_fen_lei_list"
                  url="/admin/gcvip/columnData/list"
                  checkStrictly
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="客户销售渠道">
                <el-select
                  v-model="detailData.ke_hu_xiao_shou_qu_dao"
                  size="mini"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in channelList"
                    :key="item.key"
                    :label="item.key"
                    :value="item.val"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="客户地址">
                <c-cascader-address :list.sync="detailData.address_list" checkStrictly />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24" :md="24">
              <el-form-item label="客户详细地址">
                <el-input clearable v-model="detailData.address" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24" :md="24">
              <el-form-item label="客户需求">
                <el-input
                  v-model="detailData.customer_demand"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="旺旺号">
                <el-input clearable v-model="detailData.alibaba" />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="客户来源">
                <el-select style="width: 100%" placeholder="请选择" v-model="detailData.lai_yuan">
                  <el-option
                    v-for="(item, index) in sourceList"
                    :key="index"
                    :label="item.key"
                    :value="item.val"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="法人">
                <el-input clearable v-model="detailData.certificate_code" />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="法人电话">
                <el-input clearable v-model="detailData.certificate_phone" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="开户银行">
                <el-input clearable v-model="detailData.deposit_bank" />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="银行账号">
                <el-input clearable v-model="detailData.deposit_bank_number" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="统一社会信用代码">
                <el-input clearable v-model="detailData.tax_id" />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="协同人员" prop="xie_cong_ren_yuan_id_list">
                <el-select
                  v-model="detailData.xie_cong_ren_yuan_id_list"
                  style="width: 100%"
                  placeholder="可搜索查询"
                  default-first-option
                  filterable
                  collapse-tags
                  multiple
                  clearable
                >
                  <el-option
                    v-for="(item, index) in saleList"
                    :key="index"
                    :label="item.nick_name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="图片附件">
                <e-upload-image :list.sync="detailData.photo_list" isDelete />
              </el-form-item>
            </el-col>
            <el-col :lg="12" :md="12">
              <el-form-item label="接待状态" prop="jie_dai_zhuang_tai">
                <el-select v-model="detailData.jie_dai_zhuang_tai" style="width: 100%">
                  <el-option
                    v-for="(item, index) in jieDaiList"
                    :key="index"
                    :label="item.key"
                    :value="item.val"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :md="12">
              <el-form-item label="状态">
                <el-switch active-value="激活" inactive-value="禁用" v-model="detailData.state" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 隐藏字段 -->
        <el-form v-if="false">
          <el-form-item label="曾用名">
            <el-input clearable readonly v-model="detailData.used_name" />
          </el-form-item>
          <el-form-item label="传真">
            <el-input clearable v-model="detailData.fax" />
          </el-form-item>
          <el-form-item label="月任务">
            <el-input-number
              :controls="false"
              :precision="2"
              v-model.number="detailData.month_task"
            />
          </el-form-item>
          <el-form-item label="年任务">
            <el-input-number
              :controls="false"
              :precision="2"
              v-model.number="detailData.year_task"
            />
          </el-form-item>
          <el-form-item label="经销期限">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="detailData.period_distribution"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="信用额度">
            <el-input-number
              :controls="false"
              :precision="2"
              clearable
              v-model.number="detailData.credit_lines"
            />
          </el-form-item>
          <el-form-item label="账期">
            <el-input type="number" v-model.number="detailData.payment_days">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="月结日期：每月" label-width="120px">
            <el-input type="number" v-model.number="detailData.monthly_statement_date">
              <template slot="append">号(零代表当月月末)</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" v-debounce="popupConfirm">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog width="500px" title="重复提示" :visible.sync="repeatShow" append-to-body>
      <div>
        <div class="flex">
          <div>
            <el-link
              type="warning"
              class="vxe-icon-question-circle f-s-24 cursor-default m-t-2"
              disabled
            />
          </div>
          <div class="flex-1 m-l-10">
            <div class="f-s-16 c-black m-t-5">联系人电话已存在!</div>
            <div class="m-t-10 c-gray-deep">如确认输入无误，请联系所属业务员处理客户归属问题!</div>
            <div class="repeat-info">
              <div class="flex c-red">
                <span class="flex-1">涉及客户:{{ repeatData.customer_name }}</span>
                <span>联系人电话:{{ repeatData.phone }}</span>
              </div>
              <div class="flex c-gray-deep m-t-10">
                <span class="flex-1">所属业务:{{ repeatData.sales_man }}</span>
                <span>联系手机:{{ repeatData.saler_phone }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [String, Number],
      default: null
    },
    salerName: {
      type: String,
      default: ''
    },
    salerId: {
      type: [String, Number],
      default: ''
    },
    isLockJieDaiStatus: {
      type: Boolean,
      default: false
    },
    isLockSaler: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      repeatShow: false,
      repeatData: {},
      saleList: [],
      channelList: [
        {
          key: '线下经销',
          val: '线下经销'
        },
        {
          key: '经上销售',
          val: '经上销售'
        }
      ],
      sourceList: [
        {
          key: '电商',
          val: '电商'
        },
        {
          key: '线下',
          val: '线下'
        }
      ],
      jieDaiList: [
        {
          key: '待接待',
          val: '待接待'
        },
        {
          key: '已接待',
          val: '已接待'
        }
      ],
      detailData: {
        id: '',
        customer_name: '', // 客户企业名称
        history_level: '', // 客户等级
        saler_id: '', // 所属业务id
        sales_man: '', // 所属业务
        li_shi_ye_wu_yuan_list: [], // 历史跟进人
        linkman: '', // 联系人
        commission_rate: 0, // 提成比例
        phone: '', // 联系人电话
        wei_xin: '', // 联系人微信
        zhu_ying_chan_pin: '', // 主营产品
        ke_hu_xiao_shou_qu_dao: '', // 客户销售渠道
        address_list: [], // 客户地址
        address: '', // 客户地址
        customer_demand: '', // 客户需求
        alibaba: '', // 旺旺号
        suo_shu_hang_ye: [], // 所属行业
        xun_pan_chan_pin_fen_lei_list: [], // 询盘产品分类
        lai_yuan: '', // 客户来源
        certificate_code: '', // 法人
        certificate_phone: '', // 法人电话
        deposit_bank: '', // 开户银行
        deposit_bank_number: '', // 银行账号
        tax_id: '', // 统一社会信用代码
        xie_cong_ren_yuan_id_list: [], // 协同人员
        photo_list: [], // 图片附件
        jie_dai_zhuang_tai: '待接待', // 接待状态
        state: '激活', // 状态

        // 隐藏字段
        used_name: '', // 曾用名
        fax: '', // 传真
        month_task: 0, // 月任务
        year_task: 0, // 年任务
        period_distribution: '', // 经销期限
        credit_lines: '', // 信用额度
        payment_days: 0, // 账期
        monthly_statement_date: 0 // 月结日期：每月
      },
      rules: {
        customer_name: [{ required: true, message: '请输入客户企业名称' }],
        saler_id: [{ required: true, message: '请选择所属业务' }]
      }
    }
  },
  computed: {
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    'detailData.saler_id': {
      handler(newVal) {
        this.saleList.forEach((item) => {
          if (item.id === newVal) {
            this.detailData.sales_man = item.nick_name
          }
        })
      },
      deep: true
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.salerName) this.detailData.sales_man = this.salerName
    if (this.salerId) this.detailData.saler_id = this.salerId
    if (this.id) {
      this.getDetailData()
    } else {
      if (!this.detailData.sales_man && !this.detailData.saler_id) {
        this.detailData.sales_man = this.selfAccountData.nick_name
        this.detailData.saler_id = this.selfAccountData.id
      }
      if (this.isLockJieDaiStatus) this.detailData.jie_dai_zhuang_tai = '已接待'
    }
    this.getSaleListData()
  },
  methods: {
    // 获取详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/customers/editVue',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.status === 200) {
          this.detailData = res.data
        }
      })
    },
    // 获取业务员列表
    getSaleListData() {
      this.$api({
        method: 'post',
        url: '/admin/account/getAccountList',
        data: {
          filterData: {
            role_name: '业务员'
          },
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let selfAccountObj = {
            nick_name: this.selfAccountData.nick_name,
            id: this.selfAccountData.id
          }
          let isExist = res.data.page.list.some((item) => {
            return item.id === selfAccountObj.id
          })
          this.saleList = res.data.page.list
          if (!isExist) this.saleList.unshift(selfAccountObj) // 不存在当前账户id，则增加到下拉
        }
      })
    },
    // 加后缀
    addSuffix() {
      let dateStr = this.$util.getDate().today.split('-').join('')
      this.detailData.customer_name = `${this.detailData.customer_name}(${dateStr})`
    },
    // 检测手机号是否重复
    checkPhoneRepeat(val) {
      this.$api({
        method: 'get',
        url: '/admin/customers/getByPhone',
        params: {
          phoneCode: val
        }
      }).then((res) => {
        if (res.data.state === 'ok' && res.data.data) {
          this.repeatData = res.data.data
          this.repeatShow = true
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/customers/saveOrUpdate',
            data: this.detailData
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('保存成功')
              this.$emit('success', this.$util.deepCopy(res.data.customer))
              this.selfShow = false
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
.repeat-info {
  margin: 10px 0 20px 0;
  padding: 10px;
  background: @colorOrangeYellow10;
  border: 1px dashed @colorRed;
  border-radius: 3px;
}
</style>
